var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTemplatesShowcasesEs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 131,
    viewBox: "0 0 131 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1072_320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.4119 38.1749C43.3355 36.019 44.9825 34.1908 47.1347 34.0427L88.1984 31.2155C90.5102 31.0563 92.4731 32.8888 92.4731 35.2061V98.5264C92.4731 100.736 90.6823 102.526 88.4731 102.526H49.5533C47.3993 102.526 45.6321 100.821 45.5558 98.6681L43.4119 38.1749Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5 100.562V100.562C46.2908 100.73 45.1977 99.8255 45.137 98.6062L42.1677 38.9999M92.25 38.9999L92.0361 35.8147M42.1677 38.9999L42.0739 37.1185C41.9641 34.9127 43.6627 33.0352 45.8685 32.9245L87.7596 30.8221C89.9396 30.7127 91.8048 32.3711 91.9511 34.549L92.0361 35.8147M42.1677 38.9999L92.0361 35.8147",
    stroke: "#333333",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.477 45.9593C51.477 44.0815 52.9992 42.5593 54.877 42.5593H97.8569C99.7347 42.5593 101.257 44.0815 101.257 45.9593V49.0001V106.468C101.257 108.346 99.7347 109.868 97.8569 109.868H54.877C52.9992 109.868 51.477 108.346 51.477 106.468V49.0001V45.9593Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4876 46.1138H72.4615C72.3164 46.1138 72.1992 45.9076 72.1992 45.652C72.1992 45.3965 72.3164 45.1902 72.4615 45.1902H82.4876C82.6327 45.1902 82.7498 45.3965 82.7498 45.652C82.7498 45.9076 82.6327 46.1138 82.4876 46.1138Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.125 87.2499L30.1915 31.7153C29.8788 29.5262 31.4016 27.4987 33.5912 27.1891L75.1447 21.3128C77.3398 21.0024 79.3686 22.5364 79.6681 24.7329L79.875 26.2499",
    stroke: "#333333",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1294 39.5289C46.0476 37.363 47.7058 35.5259 49.8687 35.3862L94.1581 32.5251C96.4639 32.3762 98.416 34.2062 98.416 36.5168V99.8553C98.416 102.064 96.6252 103.855 94.416 103.855H52.4109C50.2605 103.855 48.4949 102.155 48.4137 100.006L46.1294 39.5289Z",
    fill: "#98A9FF",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3355 59.3262H61.8843V60.2342H75.3355V59.3262Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4385 63.2962H61.8843V64.2042H71.4385V63.2962Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7988 71.9764H61.8843V72.8844H70.7988V71.9764Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5944 85.4892H61.8843V86.3972H76.5944V85.4892Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5944 89.2621H61.8843V90.1701H76.5944V89.2621Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3355 98.6616H61.8843V99.5695H75.3355V98.6616Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9752 75.9466H61.8843V76.8546H75.9752V75.9466Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4115 86.9298C87.2709 86.9298 87.1371 86.8639 87.0509 86.7504L84.6827 83.6338C84.5307 83.4341 84.5693 83.1503 84.7689 82.9983C84.9685 82.8462 85.2521 82.8848 85.4041 83.0845L87.407 85.7222L93.1808 78.5669C93.3305 78.3671 93.614 78.324 93.8159 78.4738C94.0155 78.6236 94.0586 78.9097 93.9066 79.1094L87.7722 86.7459C87.686 86.8594 87.5522 86.9275 87.4115 86.9275V86.9298Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4115 98.6163C87.2709 98.6163 87.1371 98.5505 87.0509 98.437L84.6827 95.3204C84.5307 95.1206 84.5693 94.8369 84.7689 94.6848C84.9685 94.5327 85.2521 94.5713 85.4041 94.7711L87.407 97.4087L92.5996 90.7023C92.7493 90.5025 93.0329 90.4594 93.2347 90.6092C93.4344 90.759 93.4775 91.045 93.3255 91.2448L87.7722 98.4325C87.686 98.5459 87.5522 98.6141 87.4115 98.6141V98.6163Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7466 60.2342C82.9514 60.2342 79.875 63.3106 79.875 67.1058C79.875 70.901 82.9514 73.9775 86.7466 73.9775C90.5419 73.9775 93.6183 70.901 93.6183 67.1058C93.6183 63.3106 90.5419 60.2342 86.7466 60.2342ZM86.746 63.3278C86.9501 63.3278 87.1353 63.4479 87.2177 63.6344L89.7946 69.472C89.91 69.7328 89.792 70.037 89.5315 70.1518C89.4642 70.1817 89.3936 70.1954 89.3242 70.1954C89.1263 70.1954 88.9373 70.0808 88.8524 69.888L88.3773 68.8123C88.3498 68.8168 88.3216 68.8211 88.2928 68.8211H85.2005C85.1717 68.8211 85.1438 68.8171 85.116 68.8123L84.6409 69.888C84.5264 70.1485 84.2215 70.2662 83.9617 70.1511C83.7013 70.0363 83.5829 69.7324 83.698 69.472L86.2749 63.6344C86.3573 63.4479 86.5419 63.3278 86.746 63.3278ZM86.7466 65.1195L85.5676 67.7903H87.9257L86.7466 65.1195Z",
    fill: "#32BEB0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.415,
    y: 81.0078,
    width: 7,
    height: 7,
    rx: 0.5,
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.415,
    y: 92.694,
    width: 7,
    height: 7,
    rx: 0.5,
    stroke: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1072_320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72.7141,
    height: 89.9359,
    fill: "white",
    transform: "translate(29.1431 20.532)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplatesShowcasesEs);
export default __webpack_public_path__ + "static/media/templates-showcases-es.5609dcca270e0544a4e7ea06027349e7.svg";
export { ForwardRef as ReactComponent };